// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCVRc0jGJa0-Di_j5fUDO2jSrC4IF9E6dw",
    authDomain: "purenetindia-e401c.firebaseapp.com",
    databaseURL: "https://purenetindia-e401c.firebaseio.com",
    projectId: "purenetindia-e401c",
    storageBucket: "purenetindia-e401c.appspot.com",
    messagingSenderId: "694306820998",
    appId: "1:694306820998:web:1caf7ef056b1a4a2639207",
    measurementId: "G-5VGBFMSGCQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
